// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import UsersController from "./users_controller"
application.register("users", UsersController)
import BadgesController from "./badges_controller"
application.register("badges", BadgesController)
